import { Button, Icon, Input, Popconfirm } from "antd";
import React, { useState } from "react";
import { ExamFlagListItem } from "service/exam";
import style from "./index.module.scss";

interface ListItemProps extends ExamFlagListItem {
    onSaveExamFlag: (flag: string, id?: number) => void; //保存
    onDelete: (id: number) => void; //删除
}

export default function ListItem(props: ListItemProps) {
    const {
        id,
        flag,
        createUserName,
        createTime,
        updateUserName,
        updateTime,
        onSaveExamFlag,
        onDelete
    } = props;
    const [edit, setEdit] = useState(false); //编辑状态
    const [text, setText] = useState(flag);

    //保存标记
    const handleSave = (newFlag: string, id: number) => {
        setEdit(false);
        onSaveExamFlag(newFlag, id);
    };

    return (
        <div className={style.root}>
            {!edit && (
                <div className={style.descript}>
                    <div>{flag}</div>
                    <Button type="link" onClick={() => setEdit(true)}>
                        <Icon type="edit" />
                    </Button>
                    <Popconfirm
                        placement="topLeft"
                        title={
                            <div className={style.pop}>
                                <div>删除标记内容?</div>
                                <div className={style.popSubTitle}>
                                    删除标记内容后无法恢复，确定删除？
                                </div>
                            </div>
                        }
                        okText="确定"
                        cancelText="取消"
                        onConfirm={() => onDelete(id)}
                        getPopupContainer={triggerNode =>
                            triggerNode.parentElement?.parentElement!
                        }>
                        <Button type="link">
                            <Icon type="delete" />
                        </Button>
                    </Popconfirm>
                </div>
            )}

            {edit && (
                <div className={style.edit}>
                    <Input
                        placeholder="请输入..."
                        maxLength={50}
                        style={{ width: 260 }}
                        value={text}
                        onChange={e => setText(e.target.value)}
                    />
                    <Button onClick={() => setEdit(false)}>取消</Button>
                    <Button type="primary" onClick={() => handleSave(text, id)}>
                        确定
                    </Button>
                </div>
            )}

            <div className={style.info}>
                <div className={style.info1}>
                    {createUserName} {createTime} 追加
                </div>
                {updateUserName && (
                    <div className={style.info2}>
                        {updateUserName} {updateTime} 修改
                    </div>
                )}
            </div>
        </div>
    );
}
